import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

/**
 * GeneratePesquisaClienteListaColumnDefinition
 */

type Props = {
  onActionEditar: (idSatisfacaoCliente: number | null, openState: boolean) => void;
  onActionDelete: (idSatisfacaoCliente: number | null, openState: boolean) => void;
  onActionVisualizar: (idSatisfacaoCliente: number, openNewTab: boolean) => void;
};

export const GeneratePesquisaClienteListaColumnDefinition = ({
  onActionEditar,
  onActionDelete,
  onActionVisualizar,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Realizado";
      case 0:
        return "Em Aberto";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Realizado";
      case 0:
        return "Em Aberto";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(value)}
            color={computeItemStatusColor(value)}
            description={computeItemStatusDescription(value)}
          />
        </div>
      )
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: "cliente",
      filterable: false,
      headerName: "Cliente",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: "data",
      filterable: false,
      headerName: "Data",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => {
        return (
          <span>{value !== null ? dayjs.utc(value).local().format('DD/MM/YYYY') : ''}</span>
        );
      },
    },
    {
      field: "avarage",
      filterable: false,
      headerName: "Resultado Médio",
      width: 120,
      minWidth: 120,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => {

        const formatedValue = value !== null
          ? new Intl.NumberFormat("pt-BR", { style: 'percent', minimumFractionDigits: 2 }).format(value)
          : null;

        return (
          <span>{formatedValue !== null ? formatedValue : ''}</span>
        );
      },
    },
    {
      field: 'idSatisfacaoCliente',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: "visualizar",
      filterable: false,
      headerName: "Itens",
      width: 95,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        idSatisfacaoCliente: rows['idSatisfacaoCliente'],
      }),
      renderCell: ({ value: { idSatisfacaoCliente } }) => {
        return (
          <Button
            onMouseDown={e => {
              if (e.button === 1) {
                onActionVisualizar(idSatisfacaoCliente, true);
              } else {
                onActionVisualizar(idSatisfacaoCliente, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: '3.5rem',
            }}>
            Itens
          </Button>
        );
      },
    },
  ];
}